export const NOT_SPECIFIED:string = 'Not Specified'
export const REQUIRED_MESSAGE:string = 'This field is required'
export const IS_DANGER: string = 'is-danger'
export const IS_PRIMARY: string = 'is-primary'



